"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgVideo = props => (0, jsx_runtime_1.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), (0, jsx_runtime_1.jsx)("g", {
    "data-name": "Group 777",
    children: (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Rectangle",
      fill: "none",
      d: "M0 0h24v24H0z"
    })
  }), (0, jsx_runtime_1.jsxs)("g", {
    "data-name": "Group 857",
    children: [(0, jsx_runtime_1.jsxs)("g", {
      "data-name": "Group 857",
      children: [(0, jsx_runtime_1.jsx)("g", {
        "data-name": "Path 550",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 554",
          d: "M6.71 7.153c0-.924-.322-1.174-.835-1.174s-.837.279-.837 1.013v.661H3.513V7.09c0-1.643.821-2.582 2.406-2.582s2.406.939 2.406 2.582v.264a2 2 0 01-1.13 2.113 2.1 2.1 0 011.13 2.157v.807c0 1.643-.822 2.581-2.406 2.581s-2.406-.938-2.406-2.581v-.853h1.525v.955c0 .733.323 1.012.837 1.012s.835-.25.835-1.158v-.809c0-.953-.322-1.3-1.056-1.3h-.543V8.811h.63c.6 0 .969-.264.969-1.085z",
          fill: "#2d5dec"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Path 551",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 555",
          d: "M9.296 7.182c0-1.731.791-2.67 2.465-2.67 1.584 0 2.406.939 2.406 2.582v.264H12.64V6.99c0-.734-.323-1.013-.837-1.013-.571 0-.894.279-.894 1.262v1.878a1.537 1.537 0 011.5-.909c1.188 0 1.79.835 1.79 2.347v1.878a2.453 2.453 0 01-4.9.243q-.006-.121 0-.243zm1.612 3.508v1.85c0 .733.323 1 .837 1s.835-.264.835-1v-1.85c0-.734-.323-1.012-.835-1.012s-.837.278-.837 1.012z",
          fill: "#2d5dec"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Path 552",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 556",
          d: "M15.064 7.09a2.454 2.454 0 014.9-.28 2.187 2.187 0 010 .28v5.341a2.453 2.453 0 11-4.9.243q-.006-.121 0-.243zm1.615 5.443c0 .733.322 1.012.835 1.012s.837-.279.837-1.012V6.99c0-.734-.323-1.013-.837-1.013s-.835.279-.835 1.013z",
          fill: "#2d5dec"
        })
      }), (0, jsx_runtime_1.jsx)("g", {
        "data-name": "Path 553",
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 557",
          d: "M22.08 4.512a1.453 1.453 0 11-1.453 1.453 1.447 1.447 0 011.44-1.452zm0 2.171a.719.719 0 10-.719-.719.72.72 0 00.719.719z",
          fill: "#2d5dec"
        })
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      "data-name": "Group 858",
      fill: "#2d5dec",
      children: [(0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 558",
        d: "M23.03 13.822a5.246 5.246 0 00-2.22-4.041V11.9a3.156 3.156 0 01.72 1.922c0 2.294-2.937 4.3-6.869 4.98v1.521c4.867-.748 8.369-3.333 8.369-6.501z"
      }), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 559",
        d: "M1.967 13.822a3.148 3.148 0 01.7-1.9V9.79a5.237 5.237 0 00-2.2 4.029c0 3.52 4.316 6.326 10.033 6.686v-1.509c-4.737-.337-8.533-2.566-8.533-5.174z"
      })]
    }), (0, jsx_runtime_1.jsx)("g", {
      "data-name": "Group 859",
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 560",
        d: "M12.876 19.8l-2.024 1.039-2.024 1.039.112-2.272.112-2.272 1.912 1.233z",
        fill: "#2d5dec"
      })
    })]
  })]
});
exports.default = SvgVideo;